import React, { Fragment } from 'react';
// import PropTypes from 'prop-types';
import whatYouKnow from '../../assets/images/show-what-you-know.gif';
import whatYouLearned from '../../assets/images/show-what-you-learned.gif';
import Intro from '../Intro';
import Voiceover from '../Voiceover';
import PagerButton from '../PagerButton';

const ShowWhatYouKnow = ({
  direction,
  topic,
  lead,
  image,
  title,
  paragraphText,
  vo
}) => {
  const isKnown = window.location.href.includes('prepare');

  const determineTitle = () => {
    if (title) return title;
    return `Show What You ${isKnown ? 'Know' : 'Learned'}`;
  };

  const isKnownText = `Let’s see what you already know about ${topic}. Take this quiz to find out.`;

  const isLearnedText = `Now it’s time to see what you’ve learned about ${topic}. Before answering these final questions, you can return to previous sections to review information from the module.`;

  const standardKnowVOTranscript = `Before we learn more about ${topic}, let’s see what you already know.
      Don’t worry. You aren’t expected to have all the answers yet! Just do the
      best you can.`;

  const standardLearnedVOTranscript = `Now it’s time to see what you’ve learned about ${topic}. Before
      answering these final questions, you can return to previous sections to
      review information from the module.`;

  const determineVOTranscript = () => {
    if (vo.transcript) return vo.transcript;
    return isKnown ? standardKnowVOTranscript : standardLearnedVOTranscript;
  };

  const determineDescriptionText = () => {
    if (paragraphText) return paragraphText;
    return isKnown ? isKnownText : isLearnedText;
  };

  const determineImage = () => {
    if (image) return image;
    return isKnown ? whatYouKnow : whatYouLearned;
  };

  let voiceOver = vo
    ? {
        sources: [
          {
            src: vo.src
          }
        ],
        transcript: determineVOTranscript()
      }
    : null;

  return (
    <Fragment>
      {vo && <Voiceover {...voiceOver} />}
      <Intro
        title={determineTitle()}
        lead={lead ? lead : ''}
        direction={direction ? direction : ''}
        img={determineImage()}
      />
      <p>{determineDescriptionText()}</p>
      <PagerButton />
    </Fragment>
  );
};

export default ShowWhatYouKnow;



// WEBPACK FOOTER //
// ../core/src/components/ShowWhatYouKnow/index.js